import React, { useState } from 'react';
import { isValidZip, isKnownZip, distanceMiles } from '../../utils/distance';
import VendorCard from '../vendor/VendorCard';

// ─── Host Success + Matched Vendors ──────────────────────────────────────────
function HostSuccessMatches({ hostEvent, hostConfirm, vendors, openMessage, sendBookingRequest, bookingRequests, setTab, vendorCalendars, setVendorCalendars, onSubmitAnother }) {
  const [contacted, setContacted] = useState([]);
  const neededCats = hostEvent?.vendorCategories || [];
  const eventZip   = hostEvent?.eventZip || '';
  const hasZip     = isValidZip(eventZip) && isKnownZip(eventZip);

  const matched = vendors
    .filter(v => neededCats.length === 0 || [...(v.allCategories || [v.category]), ...(v.serviceCategories || [])].some(c => neededCats.includes(c)))
    .map(v => {
      const dist    = hasZip ? distanceMiles(v.homeZip, eventZip) : null;
      const inRange = !hasZip ? true : (dist === null ? true : dist <= v.radius);
      return { ...v, dist, inRange };
    })
    .filter(v => v.inRange)
    .sort((a, b) => (a.dist ?? 999) - (b.dist ?? 999));

  return (
    <div>
      <div style={{background:'#d4f4e0',border:'1px solid #b8e8c8',borderRadius:12,padding:'24px 28px',marginBottom:32}}>
        <div style={{fontSize:32,marginBottom:8}}>✅</div>
        <h2 style={{fontFamily:'Playfair Display,serif',fontSize:24,color:'#1a6b3a',marginBottom:8}}>Event submitted!</h2>
        <p style={{fontSize:14,color:'#2d7a50',marginBottom:4}}>
          <strong>{hostConfirm?.eventName}</strong> has been received. Ref: <strong>{hostConfirm?.ref}</strong>
        </p>
        <p style={{fontSize:13,color:'#2d7a50',marginBottom:16}}>A confirmation was sent to {hostConfirm?.email}</p>
        <div style={{background:'#fdf4dc',border:'1px solid #ffd966',borderRadius:8,padding:'12px 16px',marginBottom:16,fontSize:13,color:'#7a5a10',lineHeight:1.5}}>
          <strong>⏳ Pending Review:</strong> Your event will be reviewed by our team before it goes live. You'll be notified once it's approved.
        </div>
        <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>
          <button onClick={()=>setTab('my-calendar')} style={{background:'#1a6b3a',color:'#fff',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
            📅 View My Event Calendar
          </button>
          <button onClick={onSubmitAnother} style={{background:'none',border:'1.5px solid #1a6b3a',color:'#1a6b3a',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}>
            + Submit Another Event
          </button>
        </div>
      </div>

      <h3 style={{fontFamily:'Playfair Display,serif',fontSize:22,marginBottom:6}}>
        {matched.length > 0
          ? `${matched.length} Vendor${matched.length !== 1 ? 's' : ''} Match Your Event`
          : 'No Matching Vendors Yet'}
      </h3>
      <p style={{fontSize:14,color:'#7a6a5a',marginBottom:20}}>
        {neededCats.length > 0
          ? `Vendors in ${neededCats.join(', ')} within travel range of ${eventZip}.`
          : `All approved vendors within travel range of ${eventZip}.`}
        {hostConfirm?.isPending
          ? ' Once your event is approved, you can invite these vendors.'
          : ' Send a booking request to any vendor below.'}
      </p>
      {hostConfirm?.isPending && (
        <div style={{background:'#fdf4dc',border:'1px solid #ffd966',borderRadius:8,padding:'10px 16px',marginBottom:16,fontSize:13,color:'#7a5a10'}}>
          Your event is pending admin approval. Once approved, you will be able to see full vendor details and invite vendors to your event.
        </div>
      )}

      {matched.length === 0
        ? <div className="empty-state"><div className="big">🔍</div><p>No approved vendors match your categories yet — check back as more sign up!</p></div>
        : <div className="vendor-grid">
            {matched.map(v => (
              <VendorCard key={v.id} v={v} contacted={contacted} setContacted={setContacted} showDist={hasZip} openMessage={openMessage} sendBookingRequest={sendBookingRequest} bookingRequests={bookingRequests} hostEvent={hostEvent} setTab={setTab} vendorCalendars={vendorCalendars} setVendorCalendars={setVendorCalendars} userEvents={[]} />
            ))}
          </div>
      }
    </div>
  );
}

export default HostSuccessMatches;
